import { render, staticRenderFns } from "./SelectStandards.vue?vue&type=template&id=a0702566&scoped=true"
import script from "./SelectStandards.vue?vue&type=script&lang=js"
export * from "./SelectStandards.vue?vue&type=script&lang=js"
import style0 from "./SelectStandards.vue?vue&type=style&index=0&id=a0702566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0702566",
  null
  
)

export default component.exports